import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import "aos/dist/aos.css";
import { RippleButton } from "../../pages/Home/Home";
import { useNavigate } from "react-router-dom";

const Navbar = ({ logo: logoSrc }) => {
    const navigate = useNavigate();

    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    const links = ['Finance', 'Environnement', 'Agriculture', 'Nutrition'];

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', fn);
        return () => window.removeEventListener('scroll', fn);
    }, []);

    useEffect(() => {
        const fn = () => {
            if (window.innerWidth >= 768) setMenuOpen(false);
        };
        window.addEventListener('resize', fn);
        return () => window.removeEventListener('resize', fn);
    }, []);

    const handleNavigation = (link) => {
        switch (link) {
            case "Finance":
                navigate("/finance");
                break;

            case "Environnement":
                navigate("/environnement");
                break;

            case "Agriculture":
                navigate("/agriculture");
                break;

            case "Nutrition":
                navigate("/nutrition");
                break;

            default:
                break;
        }

        setMenuOpen(false);
    };

    return (
        <nav style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 100,
            transition: 'all 0.4s ease',
            background: scrolled ? 'rgba(248,245,240,0.92)' : 'transparent',
            backdropFilter: scrolled ? 'blur(20px)' : 'none',
            borderBottom: scrolled ? '1px solid rgba(249,115,22,0.12)' : '1px solid transparent',
            animation: 'navSlideDown 0.6s ease both',
        }}>
            <div style={{
                maxWidth: 1140,
                margin: '0 auto',
                padding: '0 1.25rem',
                height: 64,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>

                {/* LOGO */}
                <button
                    onClick={() => navigate("/")}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.65rem',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: 30,
                            height: 30,
                            objectFit: 'contain',
                            animation: 'pulse 1.5s infinite'
                        }}
                    />

                    <span
                        className="syne"
                        style={{
                            fontWeight: 700,
                            fontSize: 17,
                            color: scrolled ? '#1a1208' : '#fff'
                        }}
                    >
                        Tumaini Letu
                    </span>
                </button>

                {/* DESKTOP LINKS */}
                <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-links">
                    {links.map((l) => (
                        <button
                            key={l}
                            onClick={() => handleNavigation(l)}
                            style={{
                                fontSize: 14,
                                fontWeight: 400,
                                color: scrolled ? '#3d3020' : 'rgba(255,255,255,0.8)',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontFamily: 'DM Sans, sans-serif',
                                transition: 'color 0.2s',
                            }}
                            onMouseEnter={e => e.target.style.color = '#f97316'}
                            onMouseLeave={e => e.target.style.color = scrolled ? '#3d3020' : 'rgba(255,255,255,0.8)'}
                        >
                            {l}
                        </button>
                    ))}
                </div>

                {/* ACTION BUTTONS */}
                <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '0.6rem' }} className="desktop-btns">
                        <RippleButton style={{
                            padding: '0.5rem 1.1rem',
                            borderRadius: 10,
                            background: '#f97316',
                            color: '#fff',
                            fontSize: 13,
                            fontWeight: 500,
                        }}>
                            Se connecter
                        </RippleButton>

                        <RippleButton style={{
                            padding: '0.5rem 1.1rem',
                            borderRadius: 10,
                            background: 'transparent',
                            color: scrolled ? '#f97316' : '#fff',
                            border: `1.5px solid ${scrolled ? '#f97316' : 'rgba(255,255,255,0.5)'}`,
                            fontSize: 13,
                            fontWeight: 500,
                        }}>
                            S'inscrire
                        </RippleButton>
                    </div>

                    {/* HAMBURGER */}
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="hamburger"
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 5
                        }}
                    >
                        {[0, 1, 2].map(i => (
                            <span
                                key={i}
                                style={{
                                    display: 'block',
                                    width: 22,
                                    height: 2,
                                    background: scrolled ? '#1a1208' : '#fff',
                                    borderRadius: 2,
                                    transition: 'all 0.3s ease',
                                    transform: menuOpen
                                        ? (i === 0 ? 'rotate(45deg) translate(5px,5px)'
                                            : i === 2 ? 'rotate(-45deg) translate(5px,-5px)'
                                                : 'scaleX(0)')
                                        : 'none',
                                    opacity: menuOpen && i === 1 ? 0 : 1,
                                }}
                            />
                        ))}
                    </button>
                </div>
            </div>

            {/* MOBILE MENU */}
            <div style={{
                overflow: 'hidden',
                background: 'rgba(248,245,240,0.97)',
                backdropFilter: 'blur(20px)',
                maxHeight: menuOpen ? 400 : 0,
                transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)',
                borderTop: menuOpen ? '1px solid rgba(249,115,22,0.1)' : 'none',
            }}>
                <div style={{
                    padding: '1rem 1.25rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.1rem'
                }}>
                    {links.map((l) => (
                        <button
                            key={l}
                            onClick={() => handleNavigation(l)}
                            style={{
                                display: 'block',
                                padding: '0.75rem 0',
                                borderBottom: '1px solid rgba(249,115,22,0.08)',
                                color: '#3d3020',
                                textDecoration: 'none',
                                fontSize: 15,
                                fontWeight: 400,
                                fontFamily: 'DM Sans, sans-serif',
                                background: 'none',
                                borderLeft: 'none',
                                borderRight: 'none',
                                borderTop: 'none',
                                textAlign: 'left',
                                cursor: 'pointer'
                            }}
                        >
                            {l}
                        </button>
                    ))}

                    <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '0.75rem' }}>
                        <RippleButton style={{
                            flex: 1,
                            padding: '0.65rem',
                            borderRadius: 10,
                            background: '#f97316',
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 500
                        }}>
                            Se connecter
                        </RippleButton>

                        <RippleButton style={{
                            flex: 1,
                            padding: '0.65rem',
                            borderRadius: 10,
                            background: 'transparent',
                            color: '#f97316',
                            border: '1.5px solid #f97316',
                            fontSize: 14,
                            fontWeight: 500
                        }}>
                            S'inscrire
                        </RippleButton>
                    </div>
                </div>
            </div>

            <style>{`
                @media (min-width: 768px) { .hamburger { display: none !important; } }
                @media (max-width: 767px) { .desktop-links, .desktop-btns { display: none !important; } }
            `}</style>
        </nav>
    );
};

export default Navbar;